import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

// Shape of the router context plumbed in from `createRouter({ context })` in App.tsx.
// Routes access this via `Route.useRouteContext()` or in `beforeLoad({ context })`.
export type RouterContext = {
  queryClient: QueryClient;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
});
